import React from "react";
import { Link } from 'react-router-dom'



const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const Features = ({data}) => {
    return (
        <section className="wpo-features-area">
            <div className="container">
                <div className="features-wrap">
                    <div className="row">
                        {data.features.map((feature, key) => (
                        <div
                            className={`col col-lg-3 col-md-6 col-12 ${
                            key === 0 ? "top-left" :
                            key === 1 ? "top-right" :
                            key === 2 ? "bottom-left" :
                            key === 3 ? "bottom-right" : ""
                            }`}
                            key={key}
                        >
                            
                            <div className="feature-item-wrap">
                                <div className="feature-item">
                                    <div className="icon">
                                        <i className={feature.flaticon}></i>
                                    </div>
                                    <div className="feature-text">
                                        <h2><Link onClick={ClickHandler} to={feature.to}>{feature.featuresText}</Link></h2>
                                    </div>
                                </div>
                                <div className="feature-item-hidden">
                                    <div className="icon">
                                        <i className={feature.flaticonHidden}></i>
                                    </div>
                                    <div className="feature-text">
                                        <h2><Link onClick={ClickHandler} to={feature.to}>{feature.featuresText}</Link></h2>
                                        <p>{feature.paragraphText}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Features;